import { useAuth } from '@clerk/nextjs';
import { useQuery } from '@tanstack/react-query';

import { StaleTime } from 'queries/types';

import { loyaltySessionQuery } from './queries';

export const useLoyaltySession = (
  cartId: string,
  config?: Partial<ReturnType<typeof loyaltySessionQuery>>,
) => {
  const { isSignedIn } = useAuth();

  const { data, isPending } = useQuery({
    ...loyaltySessionQuery({ cartId }),
    staleTime: StaleTime.FIVE_MIN,
    enabled: !!isSignedIn && config?.enabled,
    ...config,
  });

  return {
    loyaltySession: data?.loyaltySession,
    isLoading: isPending,
  };
};
